
export class LocationFormatter {
	static readonly NORTH = 'N';
	static readonly SOUTH = 'S';
	static readonly EAST = 'E';
	static readonly WEST = 'W';

	static roundToDecimal(inputNum: number, numPoints: number): number {
		const multiplier = Math.pow(10, numPoints);
		return Math.round(inputNum * multiplier) / multiplier;
	}

	static decimalToDMS(location: number, hemisphere: string): [number, number, number, string] {
		if (location < 0) location = -location;

		const degrees = Math.floor(location);
		const minutesFromRemainder = (location - degrees) * 60;
		const minutes = Math.floor(minutesFromRemainder);
		const secondsFromRemainder = (minutesFromRemainder - minutes) * 60;
		const seconds = this.roundToDecimal(secondsFromRemainder, 2);

		return [degrees, minutes, seconds, hemisphere];
	}

	static decimalLatToDMS(location: number): [number, number, number, string] {
		const hemisphere = location < 0 ? this.SOUTH : this.NORTH;
		return this.decimalToDMS(location, hemisphere);
	}

	static decimalLongToDMS(location: number): [number, number, number, string] {
		const hemisphere = location < 0 ? this.WEST : this.EAST;
		return this.decimalToDMS(location, hemisphere);
	}

	static DMSToDecimal(degrees: number, minutes: number, seconds: number, hemisphere: string): number {
		let ddVal = degrees + minutes / 60 + seconds / 3600;
		if (hemisphere === this.SOUTH || hemisphere === this.WEST) {
			ddVal *= -1;
		}
		return this.roundToDecimal(ddVal, 5);
	}
}
